import React from 'react';
import PropTypes from 'prop-types';
import ButtonGroup from "../ButtonGroup";
import { ALL_PAYWITH_OPTIONS, DEFAULT_PAYWITH_OPTIONS } from "./primitives";

var PayWithButtonGroup = function PayWithButtonGroup(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onChange = _ref.onChange,
      _ref$pointsPlusPayEna = _ref.pointsPlusPayEnabled,
      pointsPlusPayEnabled = _ref$pointsPlusPayEna === void 0 ? false : _ref$pointsPlusPayEna,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'sm' : _ref$size,
      value = _ref.value;
  var options = pointsPlusPayEnabled ? ALL_PAYWITH_OPTIONS : DEFAULT_PAYWITH_OPTIONS;
  return /*#__PURE__*/React.createElement(ButtonGroup, {
    disabled: disabled,
    name: "pay-with-button-group",
    onChange: onChange,
    options: options,
    size: size,
    value: value,
    variant: "primary",
    width: [1, 'auto']
  });
};

PayWithButtonGroup.propTypes = {
  pointsPlusPayEnabled: PropTypes.bool,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array])
};
export default PayWithButtonGroup;